import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';

export const subscriptionApi = createApi({
  reducerPath: 'subscriptionApi',
  baseQuery: fetchBaseQuery({ baseUrl: 'https://fetc.in/api/v1/new' }),
  tagTypes: ['Subscription'],

  endpoints: (builder) => ({
    submitSubscription: builder.mutation({
      query: (data) => ({
        url: '/sub',
        method: 'POST',
        body: data,
        headers: {
          'Content-Type': 'application/json',
        },
      }),
      invalidatesTags: ['Subscription'],
    }),

    getAllSubscribers: builder.query({
      query: () => '/subscribers',
      providesTags: ['Subscription'],
    }),
  }),
});

export const {
  useSubmitSubscriptionMutation,
  useGetAllSubscribersQuery,
} = subscriptionApi;
